import React from 'react';
import { EditButton } from 'admin-on-rest';

const EditButtonWithPermission = ({ resource, path, permissions, ...props }) => (
  permissions.edit ? <EditButton {...props} resource={resource} basePath={path || props.basePath} /> : null
);

export default EditButtonWithPermission;

